import { useEffect } from 'react';
import AIAvatarHero from './components/AIAvatarHero';
import AIAvatarWhy from './components/AIAvatarWhy';
import AIAvatarForWhom from './components/AIAvatarForWhom';
import AIAvatarUseCases from './components/AIAvatarUseCases';
import AIAvatarBenefits from './components/AIAvatarBenefits';
import AIAvatarProcess from './components/AIAvatarProcess';
import AIAvatarResults from './components/AIAvatarResults';
import AIAvatarDeliverables from './components/AIAvatarDeliverables';
import AIAvatarLeadForm from './components/AIAvatarLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO } from '../../utils/seo';

export default function AIAvatarPage() {
  useSEO({
    title: 'ИИ-Аватар для бизнеса | Цифровой двойник: видео-контент 24/7 без студии | Нейро-маркетинг',
    description: 'Создайте цифрового двойника и генерируйте видео-контент 24/7 без камер, студий и грима. Экономия до 90% расходов на продакшн. Выход на 20+ языков. ИИ-аватар для экспертов, онлайн-школ и бизнеса.',
    keywords: 'ИИ-аватар, цифровой двойник, нейро-маркетинг, видео-контент, ИИ для бизнеса',
    canonical: '/AI-avatar',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <AIAvatarHero />
      <AIAvatarWhy />
      <AIAvatarForWhom />
      <AIAvatarUseCases />
      <AIAvatarBenefits />
      <AIAvatarProcess />
      <AIAvatarResults />
      <AIAvatarDeliverables />
      <AIAvatarLeadForm />
      <Footer />
    </div>
  );
}
